import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import { Router} from "react-router-dom";
import appStore from './app.store'
import './styles/main.scss';
import App from './app';
import history from './history';
import {registerHttpInterceptor} from './services/http';

// docs/access/slice-3b-plan.md §3.3 — registered once, here, on the default axios instance.
registerHttpInterceptor();

appStore.subscribe(() => console.log('store',appStore.getState()));

ReactDOM.render(
<Router history={history}>
  <Provider store={appStore}>
    <App />
  </Provider>
</Router>, document.getElementById('root'));
